var map = {
	"./1/symbol_0.png": "f28a",
	"./1/symbol_1.png": "a8c5",
	"./1/symbol_10_x10.png": "f035",
	"./1/symbol_10_x100.png": "dbb3",
	"./1/symbol_10_x1000.png": "7308",
	"./1/symbol_10_x12.png": "6b0e",
	"./1/symbol_10_x15.png": "d6dc",
	"./1/symbol_10_x2.png": "70a2",
	"./1/symbol_10_x20.png": "6198",
	"./1/symbol_10_x25.png": "d54b",
	"./1/symbol_10_x250.png": "6453",
	"./1/symbol_10_x3.png": "fb96",
	"./1/symbol_10_x4.png": "97c5",
	"./1/symbol_10_x5.png": "9f7f",
	"./1/symbol_10_x50.png": "9ccb",
	"./1/symbol_10_x500.png": "90bc",
	"./1/symbol_10_x6.png": "e50f",
	"./1/symbol_10_x8.png": "f95a",
	"./1/symbol_2.png": "657a",
	"./1/symbol_3.png": "418f",
	"./1/symbol_4.png": "9c2d",
	"./1/symbol_5.png": "f9e6",
	"./1/symbol_6.png": "c568",
	"./1/symbol_7.png": "93d7",
	"./1/symbol_8.png": "6e3d",
	"./1/symbol_9.png": "f1e5",
	"./slotmachine_free.png": "608b",
	"./slotmachine_normal.png": "8f16"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "031b";